<div class="" style="padding:30px 60px">
    <div class="row mb-2 mt-3">
        <div class="col-12 col-lg-8 d-flex align-items-end">
            <h6 style="color:#126db3;margin-left:-15px;">
                {{"historic.action_plans"  | translate}}


            </h6>
            <span class="fa-stack fa-1x ml-2 cursor" (click)="addNewPlan()" style="font-size: 12px;top:-5px">
                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                <i class="fas fa-plus fa-stack-1x"></i>
            </span>

        </div>
        <div class="col-12 col-lg-4">
            <div class="input-group search-input">
                <input class="form-control" placeholder="{{'globals.search'  | translate}}" type="text" #filter
                    [(ngModel)]="search" />

                <div class="input-group-append search-bar">
                    <span class="input-group-text search"><i class="fas fa-search"></i></span>
                    <!-- <span class="input-group-text">
                            <span class="fa-stack fa-1x ml-lg-4">
                                <i class="fa fa-circle fa-stack-2x icon-background"></i>
                                <i class="fas fa-filter fa-stack-1x"></i>
                            </span></span> -->
                </div>
            </div>
        </div>
    </div>

    <div class="row bg-white contenedor-principal" style="position: relative;z-index: 1;">
        <div *ngIf="smallSize" class="col-12 col-lg-4 py-3 sticky-top bg-white">
            <div class="col-12">
                <label for=""> <strong>
                        {{"action_plan.name_pda"  | translate}}
                    </strong> <i *ngIf="!action_clicked" class="fas fa-sort text-secondary" style="cursor: pointer;"
                        (click)="order('nombre')"></i>
                    <i *ngIf="action_clicked && ordenar" class="fas fa-sort-down text-secondary"
                        style="cursor: pointer;" (click)="order('nombre')"></i>
                    <i *ngIf="action_clicked && !ordenar" class="fas fa-sort-up text-secondary" style="cursor: pointer;"
                        (click)="order('nombre')"></i></label>
            </div>
        </div>
        <div *ngIf="smallSize" class="col-12 col-lg-2 py-3 sticky-top bg-white ">
            <div class="col-12">
                <label for=""><strong>
                        {{"action_plan.author"  | translate}}
                    </strong> <i *ngIf="!autor_clicked" class="fas fa-sort text-secondary" style="cursor: pointer;"
                        (click)="order('autor')"></i>
                    <i *ngIf="autor_clicked && ordenar" class="fas fa-sort-down text-secondary" style="cursor: pointer;"
                        (click)="order('autor')"></i>
                    <i *ngIf="autor_clicked && !ordenar" class="fas fa-sort-up text-secondary" style="cursor: pointer;"
                        (click)="order('autor')"></i></label>

            </div>
        </div>
        <div *ngIf="smallSize" class="col-12 col-lg-2 py-3 sticky-top bg-white">
            <div class="col-12">
                <label for=""><strong>
                        {{"action_plan.leader"  | translate}}
                    </strong> <i *ngIf="!lider_clicked" class="fas fa-sort text-secondary" style="cursor: pointer;"
                        (click)="order('lider')"></i>
                    <i *ngIf="lider_clicked && ordenar" class="fas fa-sort-down text-secondary" style="cursor: pointer;"
                        (click)="order('lider')"></i>
                    <i *ngIf="lider_clicked && !ordenar" class="fas fa-sort-up text-secondary" style="cursor: pointer;"
                        (click)="order('lider')"></i> </label>

            </div>
        </div>
        <div *ngIf="smallSize" class="col-12 col-lg-3 py-3 sticky-top bg-white">
            <div class="col-12">
                <label for=""><strong>
                        {{"action_plan.creation_date"  | translate}}
                    </strong> <i *ngIf="!date_clicked" class="fas fa-sort text-secondary" style="cursor: pointer;"
                        (click)="order('fecha_creacion')"></i>
                    <i *ngIf="date_clicked && ordenar" class="fas fa-sort-down text-secondary" style="cursor: pointer;"
                        (click)="order('fecha_creacion')"></i>
                    <i *ngIf="date_clicked && !ordenar" class="fas fa-sort-up text-secondary" style="cursor: pointer;"
                        (click)="order('fecha_creacion')"></i> </label>
            </div>
        </div>
        <div *ngIf="smallSize" class="col-12 col-lg-1 py-3 sticky-top bg-white">
            <div class="col-12 invisible" style="color:#126db3">
                h
            </div>
        </div>
    </div>
    <div class="row bg-white contenedor">
        <ng-container *ngFor="let data of dataSource | search:search:modulo; index as i; first as isFirst">

            <div class="row col-12 hover ml-1">
                <div class="col-12 col-lg-4 py-3 border-bottom" (click)="addData(data)">
                    <div *ngIf="!smallSize" class="col-12">
                        <label for=""> <strong>
                                {{"action_plan.name_pda"  | translate}}
                            </strong> <i *ngIf="!action_clicked" class="fas fa-sort text-secondary"
                                style="cursor: pointer;" (click)="order('nombre')"></i>
                            <i *ngIf="action_clicked && ordenar" class="fas fa-sort-down text-secondary"
                                style="cursor: pointer;" (click)="order('nombre')"></i>
                            <i *ngIf="action_clicked && !ordenar" class="fas fa-sort-up text-secondary"
                                style="cursor: pointer;" (click)="order('nombre')"></i></label>
                    </div>
                    <div class="col-12 alinear-nombre">
                        <span class="">{{data.nombre}}
                        </span>

                    </div>
                </div>
                <div class="col-12 col-lg-2 py-3 border-bottom">
                    <div *ngIf="!smallSize" class="col-12">
                        <label for=""> <strong>
                                {{"action_plan.author"  | translate}}
                            </strong> <i *ngIf="!autor_clicked" class="fas fa-sort text-secondary"
                                style="cursor: pointer;" (click)="order('autor')"></i>
                            <i *ngIf="autor_clicked && ordenar" class="fas fa-sort-down text-secondary"
                                style="cursor: pointer;" (click)="order('autor')"></i>
                            <i *ngIf="autor_clicked && !ordenar" class="fas fa-sort-up text-secondary"
                                style="cursor: pointer;" (click)="order('autor')"></i></label>
                    </div>
                    <div class="col-12 alinear">
                        <span class="">
                            {{data.autor}}
                        </span>
                    </div>
                </div>
                <div class="col-12 col-lg-2 py-3 border-bottom">
                    <div *ngIf="!smallSize" class="col-12">
                        <label for=""> <strong>
                                {{"action_plan.leader"  | translate}}
                            </strong> <i *ngIf="!lider_clicked" class="fas fa-sort text-secondary"
                                style="cursor: pointer;" (click)="order('lider')"></i>
                            <i *ngIf="lider_clicked && ordenar" class="fas fa-sort-down text-secondary"
                                style="cursor: pointer;" (click)="order('lider')"></i>
                            <i *ngIf="lider_clicked && !ordenar" class="fas fa-sort-up text-secondary"
                                style="cursor: pointer;" (click)="order('lider')"></i> </label>
                    </div>
                    <div class="col-12 ">
                        <span class="">
                            <!-- <ng-container *ngFor="let integrante of data.integrantes">
                                <ng-container *ngIf="integrante.tipo==1">
                                    {{integrante.usuario_organizacion.usuario.name}}
                                </ng-container>

                            </ng-container> -->

                            {{data.lider}}
                        </span>
                    </div>
                </div>
                <div class="col-12 col-lg-3 py-3 border-bottom">
                    <div *ngIf="!smallSize" class="col-12">
                        <label for=""> <strong>
                                {{"action_plan.creation_date"  | translate}}
                            </strong> <i *ngIf="!date_clicked" class="fas fa-sort text-secondary"
                                style="cursor: pointer;" (click)="order('fecha_creacion')"></i>
                            <i *ngIf="date_clicked && ordenar" class="fas fa-sort-down text-secondary"
                                style="cursor: pointer;" (click)="order('fecha_creacion')"></i>
                            <i *ngIf="date_clicked && !ordenar" class="fas fa-sort-up text-secondary"
                                style="cursor: pointer;" (click)="order('fecha_creacion')"></i> </label>
                    </div>
                    <div class="col-12 ml-xl-2">
                        <span class="">
                            {{data.fecha_creacion}}
                        </span>

                    </div>

                </div>
                <div class="col-12 col-lg-1 py-3 border-bottom">
                    <div *ngIf="!smallSize" class="col-12 invisible">
                        <label for="">{{"action_plan.creation_date"  | translate}} <i class="fas fa-sort text-secondary"
                                style="cursor: pointer;"></i> </label>
                    </div>
                    <div class="col-12 ">
                        <span class="fa-stack fa-1x cursor" (click)="addToHistoric(data)">
                            <i class="fa fa-circle fa-stack-2x icon-background"></i>
                            <i class="fas fa-archive fa-stack-1x" style="border-radius: 50%;border: 2.5px solid white;box-shadow:0 0 0 1px #0ea0a0,
                                0 0 0 1px #0ea0a0,0 0 0 3px #0ea0a0;"></i>



                        </span>
                    </div>

                </div>

            </div>

        </ng-container>

    </div>

    <!-- <div class="col-md-4 ml-auto mt-3 mt-lg-5 btns d-flex p-0 flex-row-reverse">
    
        <button class="btn  m-2 mainColor text-white">
            {{ "historic.generate_report" | translate }}
        </button>
    
    </div> -->
</div>